import { Link } from 'react-router-dom';
import { Post } from '@/mocks/posts';
import { categories } from '@/mocks/categories';
import PostCard from '@/components/base/PostCard';
import AdSlot from './AdSlot';
import NextPublishCountdown from '@/components/feature/NextPublishCountdown';

interface SidebarProps {
  recentPosts: Post[];
}

export default function Sidebar({ recentPosts }: SidebarProps) {
  return (
    <aside className="space-y-8">
      <AdSlot slot="sidebar" />

      {/* Categories */}
      <div>
        <h3 className="text-xs font-semibold text-stone-400 dark:text-stone-500 uppercase tracking-widest mb-4">
          Browse Topics
        </h3>
        <div className="space-y-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center justify-between px-4 py-2.5 rounded-lg bg-stone-50 dark:bg-stone-800 hover:bg-rose-50 dark:hover:bg-stone-700 transition-colors cursor-pointer group"
            >
              <span className="text-sm font-medium text-stone-700 dark:text-stone-300 group-hover:text-rose-600 dark:group-hover:text-rose-400 transition-colors">
                {cat.name}
              </span>
              <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: cat.color }} />
            </Link>
          ))}
        </div>
      </div>

      {/* Recent posts */}
      <div>
        <h3 className="text-xs font-semibold text-stone-400 dark:text-stone-500 uppercase tracking-widest mb-4">
          Recent Posts
        </h3>
        <div className="space-y-4">
          {recentPosts.slice(0, 5).map((post) => (
            <PostCard key={post.id} post={post} variant="compact" />
          ))}
        </div>
      </div>

      {/* Next publish countdown */}
      <NextPublishCountdown variant="sidebar" />

      {/* About blurb */}
      <div className="bg-rose-50 dark:bg-rose-900/20 rounded-lg p-5">
        <h3 className="text-sm font-bold text-stone-800 dark:text-stone-100 mb-2">About This Blog</h3>
        <p className="text-xs text-stone-500 dark:text-stone-400 leading-relaxed">
          roameurope.blog is a space for honest, thoughtful writing about love, dating, and the beautiful complexity of human relationships.
        </p>
        <Link
          to="/about"
          className="inline-block mt-3 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:text-rose-700 dark:hover:text-rose-300 cursor-pointer"
        >
          Learn more &rarr;
        </Link>
      </div>
    </aside>
  );
}
